import { Button, CardMedia } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useMemo } from 'react';
import {
	handleDownloadLinkPropsForIe,
	IDownloadAnchor,
} from 'src/utils/download';

const useStyles = makeStyles(
	() => ({
		MuiButt: {
			'&:hover': {
				backgroundColor: 'transparent !important',
			},
		},
	}),
	{}
);

interface Iprops {
	imageSrc: string;
	path: string;
	downloadName: string;
	imageClassName: string;
	mouseOver: any;
	mouseLeave: any;
}

function QuickModeDownloadButton(props: Iprops) {
	const { MuiButt } = useStyles();
	const {
		imageSrc,
		path,
		downloadName,
		imageClassName,
		mouseOver,
		mouseLeave,
	} = props;
	// リンク先
	const target: IDownloadAnchor = useMemo(
		() => ({
			download: downloadName,
			href: path,
		}),
		[downloadName, path]
	);
	// IEモード向けにpropsを差し替え
	const linkProps = useMemo(() => handleDownloadLinkPropsForIe(target), [
		target,
	]);

	return (
		<div>
			<Button
				className={MuiButt}
				{...linkProps}
				style={{ marginRight: '280px' }}
			>
				<CardMedia
					image={imageSrc}
					component="img"
					className={imageClassName}
					onMouseOver={mouseOver}
					onMouseLeave={mouseLeave}
				/>
			</Button>
		</div>
	);
}

export default QuickModeDownloadButton;



// WEBPACK FOOTER //
// ./src/components/QuickModeDownloadButton.tsx